import {Chip, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close.js";
import {ExternalLink} from "./ExternalLink.jsx";
import IconButton from "@mui/material/IconButton";
import {useState} from "react";
const TipBox = ({artist}) => {
    const [open, setOpen] = useState(false);
    return <span>&nbsp;
        <Chip size={"small"} clickable onClick={() =>setOpen(true)} label={"Tip"} color={"primary"}/>
        <Dialog open={open} >
        <DialogTitle>Tip {artist.name}</DialogTitle>
        <CloseIcon style={{position:"absolute",top:8,right:8}} onClick={()=>setOpen(false)}/>
            <IconButton size={"small"} style={{float: "right"}} color={"info"} onClick={() => setOpen(false)} icon={<CloseIcon />} label={"close"} />
            <DialogContent dividers>
            Click the "TIP NOW" Button below. You will be redirected to band's Venmo account.
            <br />
            <br />
            <Typography variant={"caption"}>This band tip data has been provided by <ExternalLink href={"https://storage.googleapis.com/www.tipthebandatx.live/tipthebandatx.html"} target="_blank">Tip the Band ATX</ExternalLink></Typography>
        </DialogContent>
       <DialogActions>
           <ExternalLink href={artist.venmo}>TIP NOW</ExternalLink>
       </DialogActions>
    </Dialog>
    </span>


}

export default TipBox;